import React from 'react';
import {NotificationItem} from '@/common-pages/notification/notification.service';
import globalStore from '@/services/global.state';
import {goTo} from '@/utils';

interface SysMessageProp {
  sysMessage: NotificationItem;
}

export default function SysMessage({sysMessage}: SysMessageProp) {
  const toDetail = (item: NotificationItem) => {
    globalStore.readNotification.next({
      messageId: item.id,
      messageType: 1,
    });
    globalStore.asyncSetItem('notification-detail', JSON.stringify(item));
    goTo('NotificationDetail');
  };
  return (
    <div className="rounded bg-card flex flex-row justify-between mx-3 py-1 px-2 items-center gap-2">
      <div className="flex flex-row gap-2 items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none">
          <path
            d="M12.7714 3.43832C12.6281 3.36881 12.4675 3.343 12.3096 3.36408C12.1517 3.38516 12.0034 3.45221 11.8834 3.55689L7.08283 7.69302L3.25249 7.67718C3.1425 7.67728 3.03367 7.69962 2.93253 7.74285C2.83139 7.78608 2.74004 7.8493 2.66395 7.92873C2.50543 8.0926 2.41708 8.31184 2.41768 8.53983L2.4004 15.4526C2.39928 15.6806 2.48671 15.9002 2.64427 16.0651C2.72039 16.1454 2.81202 16.2093 2.91361 16.253C3.01519 16.2968 3.12461 16.3194 3.23521 16.3196H7.10779L11.8853 20.4403C12.0055 20.5449 12.1537 20.6117 12.3116 20.6326C12.4695 20.6536 12.6301 20.6276 12.7734 20.5579C12.9187 20.4858 13.0409 20.3742 13.1258 20.2359C13.2107 20.0976 13.2549 19.9382 13.2534 19.7759V4.22224C13.2546 4.06004 13.2102 3.90077 13.1253 3.76253C13.0405 3.62429 12.9185 3.51263 12.7734 3.44024L12.7714 3.43832ZM16.0084 7.75879C15.9097 7.71164 15.8025 7.68474 15.6932 7.67969C15.584 7.67464 15.4748 7.69155 15.3721 7.72941C15.2694 7.76726 15.1754 7.8253 15.0956 7.9001C15.0157 7.97491 14.9517 8.06495 14.9072 8.16491C14.8118 8.36939 14.7982 8.6026 14.8692 8.81679C14.9401 9.03098 15.0902 9.20994 15.2888 9.31704C15.3416 9.34536 16.5922 10.0179 16.5922 11.9338C16.5922 13.9803 15.4228 14.6586 15.3839 14.6807C15.1838 14.7883 15.0332 14.9691 14.9636 15.1853C14.894 15.4016 14.9107 15.6364 15.0104 15.8405C15.0771 15.983 15.1827 16.1038 15.3152 16.1887C15.4476 16.2737 15.6015 16.3194 15.7588 16.3205C15.8883 16.3205 16.0159 16.2894 16.1309 16.2298C16.2177 16.1818 18.2613 15.0897 18.2613 11.9357C18.2613 8.89315 16.1011 7.80728 16.008 7.75927L16.0084 7.75879ZM18.6079 5.22123C18.5163 5.16077 18.4134 5.11942 18.3053 5.09967C18.1973 5.07992 18.0864 5.08217 17.9793 5.10628C17.8722 5.1304 17.771 5.17588 17.6819 5.24001C17.5928 5.30414 17.5175 5.3856 17.4606 5.4795C17.3402 5.6715 17.298 5.90233 17.3427 6.12451C17.3873 6.34668 17.5154 6.54329 17.7006 6.67387C17.7909 6.73532 19.9295 8.24364 19.9295 11.9981C19.9295 15.7608 17.8778 17.2705 17.7962 17.3267C17.6102 17.4583 17.4823 17.6566 17.4392 17.8803C17.3961 18.1039 17.4411 18.3356 17.5648 18.5268C17.6392 18.6441 17.7419 18.7407 17.8634 18.8079C17.985 18.875 18.1215 18.9104 18.2604 18.9109C18.4256 18.9108 18.587 18.8606 18.7231 18.7669C18.8403 18.6867 21.5996 16.7286 21.5996 11.9981C21.5996 7.25953 18.7284 5.30284 18.606 5.22171L18.6079 5.22123Z"
            fill="white"
          />
        </svg>
        <div
          className="text-t1 text-xs font-medium overflow-hidden"
          style={{
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
          }}
          dangerouslySetInnerHTML={{
            __html: sysMessage.messageContent,
          }}
        />
      </div>
      <div
        className="text-t1 text-xs bg-[var(--1)] rounded-xl flex items-center justify-center px-2 h-6"
        onClick={() => {
          toDetail(sysMessage);
        }}>
        Details
      </div>
    </div>
  );
}
